<template>
    <div
        :class="classText"
        class="text"
    >
        <slot name="default"></slot>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Colors } from '@/components/ui/index'

const {
    alignment = 'LEFT',
    size = 'MEDIUM',
    color = undefined,
} = defineProps<{
    alignment?: 'LEFT' | 'CENTER' | 'RIGHT'
    size?: 'SMALL' | 'MEDIUM' | 'LARGE' | 'EXTRA_LARGE'
    color?: Colors
}>()

const classText = computed(() => ({
    [size?.toLocaleLowerCase().replace('_', '-')]: true,
    [alignment?.toLocaleLowerCase()]: true,
}))
</script>

<style lang="scss" scoped>
.text {
    font-family: $sectra-font-stack;
    font-weight: 500;
    color: v-bind(color);
    margin: 0 auto 20px;
    width: 100%;
    max-width: 680px;
    line-height: 1.45rem;

    :deep(p) {
        margin: 0 0 20px;
    }

    :deep(ul) {
        list-style: disc outside;
        padding: 0 0 0 20px;
        margin: 0 0 20px;

        li {
            margin: 0 0 5px;
        }
    }

    :deep(ol) {
        list-style: decimal outside;
        padding: 0 0 0 20px;
        margin: 0 0 20px;

        li {
            margin: 0 0 5px;
        }
    }

    :deep(strong),
    :deep(b) {
        font-weight: 700;
    }

    :deep(em),
    :deep(i) {
        font-style: italic;
    }

    :deep(button),
    :deep(a) {
        cursor: pointer;
        text-decoration: underline;
    }

    &.small {
        font-size: 0.875rem;
        line-height: 1.6em;

        :deep(p) {
            margin: 0 0 20px;
        }
    }

    &.medium {
        font-size: 1rem;
        line-height: 1.6em;
    }

    &.large {
        font-size: 1.18rem;
        line-height: 1.7em;

        :deep(p) {
            margin: 0 0 40px;
        }
    }

    &.extra-large {
        font-size: 1.375rem;
        line-height: 1.6em;

        :deep(p) {
            margin: 0 0 40px;
        }
    }

    &.center {
        text-align: center;
    }

    &.left {
        text-align: left;
    }

    &.right {
        text-align: right;
    }
}
</style>
